import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatDialog } from "@angular/material/dialog";
import Swal from 'sweetalert2';
import {
  IConstatacaoModel, IEvidenciaModel,
  IOsaExecucaoMatrizConstatacaoItemModel,
  IRecomendacaoModel,
  ISalvarConstatacaoDto
} from "../../../../../models/constatacao.model";

import { MatrizConstatacoesService } from "../../../../../services/matriz-constatacao.service";
import { AuthService } from "../../../../../services/auth.service";
import { ModalCancelarComponent } from "../../../../../shared/components/modal-cancelar/modal-cancelar-component";
import { IOsaExecucaoPapelTrabalhoArquivo } from "../../../../../models/osa-execucao-papel-trabalho.model";
import { OsaExecucaoPapelTrabalhoService } from "../../../../../services/osa-execucao-papel-trabalho.service";


@Component({
  selector: 'app-modal-editar-constatacao',
  templateUrl: './modal-editar-constatacao.component.html',
  styleUrls: ['./modal-editar-constatacao.component.scss']
})
export class ModalEditarConstatacaoComponent implements OnInit {
  public form: FormGroup;
  public constatacao: IOsaExecucaoMatrizConstatacaoItemModel;
  public recomendacoesDisponiveis: IRecomendacaoModel[] = [];
  public loading = false;
  public modoVisualizacao = false;
  public podeEditar = false;
  public podeFinalizar = false;

  // Campos não editáveis carregados do Programa de Trabalho
  public numeracao: string;
  public titulo: string;
  public descricao: string;
  public riscoVinculado: string;
  public criteriosInfringidos: string;
  public evidenciasDetalhadas: IEvidenciaModel[] = [];
  public modoNovaRecomendacao = false;
  private salvouAlgo = false;
  constructor(
    private fb: FormBuilder,
    public matDialog: MatDialog,
    private dialogRef: MatDialogRef<ModalEditarConstatacaoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private matrizService: MatrizConstatacoesService,
    private authService: AuthService,
    private osaExecucaoPapelTrabalhoService: OsaExecucaoPapelTrabalhoService
  ) {
    this.modoVisualizacao = data.visualizar || false;
  }

  ngOnInit(): void {
    this.inicializarFormulario();
    this.carregarRecomendacoesDisponiveis();

    this.carregarConstatacao();
  }

  public getDescricaoStatus(status: number): string {
    switch (status) {
      case 1:
        return 'Não iniciada';
      case 2:
        return 'Em Elaboração';
      case 3:
        return 'Finalizada';
      default:
        return '-';
    }
  }


  private inicializarFormulario(): void {
    this.form = this.fb.group({
      id: [0],
      osaExecucaoMatrizConstatacaoId: [this.data?.osaExecucaoMatrizConstatacaoId || 0, Validators.required],
      osaExecucaoProgramaTrabalhoQuestaoConstatacaoId: [this.data?.osaExecucaoProgramaTrabalhoQuestaoConstatacaoId || 0, Validators.required],

      identificador: [{ value: null, disabled: true }],
      descricaoConstatacao: [{ value: null, disabled: true }],

      // ✅ SOMENTE POPULADOS
      riscoVinculado: [{ value: '', disabled: true }],
      criteriosInfringidos: [{ value: '', disabled: true }],
      evidenciasTexto: [{ value: '', disabled: true }],

      responsavelId: [null, [Validators.maxLength(50)]],
      dataHoraFinalizacao: [null],

      situacaoEncontrada: [null, Validators.required],
      causa: [null, [Validators.required, Validators.maxLength(200)]],
      efeito: [null, [Validators.required, Validators.maxLength(200)]],

      status: [this.data?.status ?? 1, Validators.required],

      recomendacaoSelecionadaId: [null],
      recomendacaoTitulo: ['', [Validators.maxLength(150)]],
      recomendacaoDescricao: ['', [Validators.required, Validators.maxLength(500)]],
      recomendacoes: this.fb.array([]),
    });

    if (this.modoVisualizacao) this.form.disable();
  }



  public onChangeRecomendacaoSelecionada(recomendacaoId: any): void {
    const id = Number(recomendacaoId);
    if (!id) {
      this.form.patchValue({
        recomendacaoTitulo: '',
        recomendacaoDescricao: ''
      });
      return;
    }

    const rec = this.recomendacoesDisponiveis.find(x => x.id === id);
    if (!rec) return;

    this.modoNovaRecomendacao = false;

    this.form.patchValue({
      recomendacaoTitulo: rec.titulo || '',
      recomendacaoDescricao: rec.descricao || ''
    });

    // bloqueia edição (existente)
    this.form.get('recomendacaoTitulo')?.disable();
    this.form.get('recomendacaoDescricao')?.disable();
  }

  public adicionarSelecionadaNaGrid(): void {
    const id = this.form.get('recomendacaoSelecionadaId')?.value;
    if (!id) return;

    const rec = this.recomendacoesDisponiveis.find(x => x.id === Number(id));
    if (!rec) return;

    // evita duplicar na grid
    const jaExiste = this.recomendacoes.controls.some(c => Number(c.get('id')?.value) === rec.id);
    if (jaExiste) {
      this.exibirAviso('Essa recomendação já foi adicionada.');
      return;
    }

    this.adicionarRecomendacao({
      id: rec.id,
      titulo: rec.titulo,
      descricao: rec.descricao
    });

    // limpa seleção
    this.form.patchValue({
      recomendacaoSelecionadaId: null,
      recomendacaoTitulo: '',
      recomendacaoDescricao: ''
    });
  }


  public novaRecomendacaoEditor(): void {
    this.modoNovaRecomendacao = true;

    this.form.patchValue({
      recomendacaoSelecionadaId: null,
      recomendacaoTitulo: '',
      recomendacaoDescricao: ''
    });

    this.form.get('recomendacaoTitulo')?.enable();
    this.form.get('recomendacaoDescricao')?.enable();
  }

  public adicionarRecomendacaoDaTela(): void {
    if (!this.modoNovaRecomendacao) return;

    const titulo = (this.form.get('recomendacaoTitulo')?.value || '').trim();
    const descricao = (this.form.get('recomendacaoDescricao')?.value || '').trim();

    if (!descricao) {
      this.exibirAviso('Informe a descrição da recomendação.');
      return;
    }

    const tituloNormalizado = titulo.toLowerCase();

    const existeNasDisponiveis = this.recomendacoesDisponiveis.some(r =>
      (r.titulo || '').trim().toLowerCase() === tituloNormalizado
    );

    const existeNasAdicionadas = this.recomendacoes.controls.some(ctrl =>
      (ctrl.get('titulo')?.value || '').trim().toLowerCase() === tituloNormalizado
    );

    if (existeNasDisponiveis || existeNasAdicionadas) {
      this.exibirAviso('Já existe uma recomendação cadastrada com esse título.');
      return;
    }

    this.adicionarRecomendacao({ id: null, titulo, descricao });

    this.modoNovaRecomendacao = false;

    this.form.patchValue({
      recomendacaoTitulo: '',
      recomendacaoDescricao: '',
      recomendacaoSelecionadaId: null
    });

    this.form.get('recomendacaoTitulo')?.disable();
    this.form.get('recomendacaoDescricao')?.disable();
  }





  private carregarConstatacao(): void {
    console.log(this.data.element.id)
    this.loading = true;
    this.matrizService.obterConstatacao(this.data.element.id)
      .then((res) => {
        if (res.sucesso && res.dados) {
          this.constatacao = res.dados;
          console.log(this.constatacao);

          this.preencherFormulario();
          // this.carregarRecomendacoesDisponiveis();
        }
      })
      .catch((err) => {
        this.exibirErro(err.mensagem?.descricao || 'Erro ao carregar constatação');
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private carregarDadosProgramaTrabalho(): void {
    // Critério 10: Carregar dados automáticos do Programa de Trabalho
    this.numeracao = this.data.constatacao?.numeracao || '';
    this.descricao = this.data.constatacao?.descricao || '';
    this.riscoVinculado = this.data.constatacao?.riscoVinculado || '';
    this.criteriosInfringidos = this.data.constatacao?.criteriosInfringidos || '';
    this.evidenciasDetalhadas = this.data.constatacao?.evidencias || [];
  }

  private preencherFormulario(): void {
    this.evidenciasDetalhadas = (this.constatacao?.evidenciasDetalhadas || []);

    this.form.patchValue({
      id: this.constatacao.id,
      osaExecucaoMatrizConstatacaoId: this.constatacao.osaExecucaoMatrizConstatacaoId,
      osaExecucaoProgramaTrabalhoQuestaoConstatacaoId: this.constatacao.osaExecucaoProgramaTrabalhoQuestaoConstatacaoId,

      identificador: this.constatacao.identificador,
      descricaoConstatacao: this.constatacao.descricaoConstatacao,

      riscoVinculado: this.constatacao.riscosVinculados || '',
      criteriosInfringidos: this.constatacao.criteriosInfringidos || '',

      responsavelId: this.constatacao.responsavelId,
      dataHoraFinalizacao: this.constatacao.dataHoraFinalizacao ? new Date(this.constatacao.dataHoraFinalizacao) : null,

      situacaoEncontrada: this.constatacao.situacaoEncontrada,
      causa: this.constatacao.causa,
      efeito: this.constatacao.efeito,
      status: this.constatacao.status
    });

    // ✅ POPULA AS RECOMENDAÇÕES
    if (this.constatacao.recomendacoes && Array.isArray(this.constatacao.recomendacoes)) {
      // Limpa o FormArray antes de popular
      while (this.recomendacoes.length !== 0) {
        this.recomendacoes.removeAt(0);
      }

      // Adiciona cada recomendação ao FormArray
      this.constatacao.recomendacoes.forEach(rec => {
        this.adicionarRecomendacao({
          id: rec.id,
          titulo: rec.titulo,
          descricao: rec.descricao
        });
      });
    }

    this.verificarPermissoes();
  }



  private carregarRecomendacoesDisponiveis(): void {
    this.recomendacoesDisponiveis = [];

    const matrizId = this.data?.matrizId;
    if (!matrizId) return;

    this.matrizService.obterRecomendacoesMatriz(matrizId)
      .then((res) => {
        if (res && res.sucesso && Array.isArray(res.dados)) {
          this.recomendacoesDisponiveis = res.dados;
        } else {
          this.recomendacoesDisponiveis = [];
        }
      })
      .catch((err) => {
        this.recomendacoesDisponiveis = [];
        console.error('Erro ao carregar recomendações:', err);
      });
  }

  // ==================== CAUSAS ====================

  get causas(): FormArray {
    return this.form.get('causas') as FormArray;
  }

  public adicionarCausa(descricao: string = ''): void {
    const causaGroup = this.fb.group({
      descricao: [descricao, [Validators.required, Validators.maxLength(200)]]
    });
    this.causas.push(causaGroup);
  }

  public removerCausa(index: number): void {
    this.causas.removeAt(index);
  }

  // ==================== EFEITOS ====================

  get efeitos(): FormArray {
    return this.form.get('efeitos') as FormArray;
  }

  public adicionarEfeito(descricao: string = ''): void {
    const efeitoGroup = this.fb.group({
      descricao: [descricao, [Validators.required, Validators.maxLength(200)]]
    });
    this.efeitos.push(efeitoGroup);
  }

  public removerEfeito(index: number): void {
    this.efeitos.removeAt(index);
  }

  // ==================== RECOMENDAÇÕES ====================

  get recomendacoes(): FormArray {
    return this.form.get('recomendacoes') as FormArray;
  }

  public adicionarRecomendacao(recomendacao?: any): void {
    const recGroup = this.fb.group({
      id: [recomendacao?.id ?? null],
      titulo: [recomendacao?.titulo || '', [Validators.maxLength(150)]],
      descricao: [recomendacao?.descricao || '', [Validators.required, Validators.maxLength(500)]],
    });

    this.recomendacoes.push(recGroup);
  }

  public removerRecomendacao(index: number): void {
    this.recomendacoes.removeAt(index);
  }

  public visualizarRecomendacao(index: number): void {
    const recGroup = this.recomendacoes.at(index) as FormGroup;

    if (!recGroup) return;

    const recomendacao = recGroup.getRawValue();

    Swal.fire({
      title: '',
      html: `
      <div style="word-break:break-word; text-align:left;">
        <p><strong>${recomendacao.titulo || 'Recomendação'}</strong></p>
        <hr/>
        <p>${recomendacao.descricao || '-'}</p>
      </div>
    `,
      icon: 'info',
      confirmButtonText: 'Fechar'
    });
  }

  public selecionarRecomendacaoExistente(index: number, recomendacaoId: number): void {
    // Critério 14: Selecionar recomendação existente
    const recomendacao = this.recomendacoesDisponiveis.find(r => r.id === recomendacaoId);
    if (recomendacao) {
      const recGroup = this.recomendacoes.at(index) as FormGroup;
      recGroup.patchValue({
        id: recomendacao.id,
        titulo: recomendacao.titulo,
        descricao: recomendacao.descricao,
        selecionada: true
      });
      recGroup.get('descricao').disable();
    }
  }

  public novaRecomendacao(index: number): void {
    // Critério 15: Nova recomendação
    const recGroup = this.recomendacoes.at(index) as FormGroup;
    recGroup.patchValue({
      id: null,
      titulo: '',
      descricao: '',
      selecionada: false
    });
    recGroup.get('descricao').enable();
  }

  // ==================== AÇÕES ====================

  public salvar(fechar: boolean = false): void {
    if (!this.validarFormulario()) return;
    this.salvouAlgo = true;
    this.loading = true;
    const dto = this.montarDTO();

    const request =
      dto.id && dto.id > 0
        ? this.matrizService.salvarItemConstatacao(dto.id, dto)   // PUT /item/{id}/salvar
        : this.matrizService.salvarConstatacao(dto);              // POST (se existir no seu backend)

    request
      .then((res) => {
        if (res.sucesso) {
          this.constatacao = res.dados;

          this.form.markAsPristine();

          this.verificarPermissoes();

          if (fechar) {
            this.dialogRef.close(true);
          }

          this.exibirSucesso(res.mensagem?.descricao || 'Constatação salva com sucesso');
        } else {
          this.exibirAviso(res.mensagem?.descricao || 'Erro ao salvar constatação');
        }
      })
      .catch((err) => {
        this.exibirErro(err?.mensagem?.descricao || 'Erro ao salvar constatação');
      })
      .finally(() => {
        this.loading = false;
        this.carregarConstatacao();
      });
  }



  public finalizar(): void {
    if (!this.validarFormulario()) return;

    Swal.fire({
      title: 'Finalizar Constatação',
      text: 'Deseja realmente finalizar esta constatação?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sim, finalizar',
      cancelButtonText: 'Cancelar'
    }).then(async (result) => {
      if (!result.value) return;

      try {
        this.loading = true;

        // ✅ Sempre salva antes de finalizar — garante responsavelPreenchimento
        const dtoSalvar = this.montarDTO();
        const resSalvar = await this.matrizService.salvarItemConstatacao(dtoSalvar.id, dtoSalvar);
        if (!resSalvar.sucesso) {
          this.exibirAviso(resSalvar.mensagem?.descricao || 'Erro ao salvar antes de finalizar');
          return;
        }
        this.constatacao = resSalvar.dados;
        this.form.markAsPristine();

        // ✅ Finaliza após salvar
        const resFinalizar = await this.matrizService.finalizarItemConstatacao(this.constatacao.id);
        if (resFinalizar.sucesso) {
          this.exibirSucesso('Constatação finalizada com sucesso');
          this.dialogRef.close(true);
        } else {
          this.exibirAviso(resFinalizar.mensagem?.descricao || 'Erro ao finalizar constatação');
        }
      } catch (err) {
        this.exibirErro(err?.mensagem?.descricao || 'Erro ao finalizar constatação');
      } finally {
        this.loading = false;
      }
    });
  }


  private executarFinalizacao(): void {
    this.loading = true;

    this.matrizService.finalizarItemConstatacao(this.constatacao.id)
      .then((res) => {
        if (res.sucesso) {
          this.exibirSucesso('Constatação finalizada com sucesso');
          this.dialogRef.close(true);
        } else {
          this.exibirAviso(res.mensagem?.descricao || 'Erro ao finalizar constatação');
        }
      })
      .catch((err) => this.exibirErro(err.mensagem?.descricao || 'Erro ao finalizar constatação'))
      .finally(() => this.loading = false);
  }

  public cancelar() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { interno: true };

    if (this.data.visualizar) {
      this.matDialog.closeAll();
      this.carregarConstatacao();
    } else {
      this.matDialog
        .open(ModalCancelarComponent, dialogConfig)
        .afterClosed();
    }
  }



  public fecharModal(): void {
    this.dialogRef.close(this.salvouAlgo);
  }
  // ==================== VALIDAÇÕES ====================

  private validarFormulario(): boolean {
    if (!this.form.get('situacaoEncontrada')?.value) {
      this.exibirAviso('O campo Situação Encontrada é obrigatório');
      return false;
    }

    if (!this.form.get('causa')?.value) {
      this.exibirAviso('O campo Causa é obrigatório');
      return false;
    }

    if (!this.form.get('efeito')?.value) {
      this.exibirAviso('O campo Efeito é obrigatório');
      return false;
    }

    if (this.recomendacoes.length === 0) {
      this.exibirAviso('É necessário incluir pelo menos uma Recomendação');
      return false;
    }

    for (let i = 0; i < this.recomendacoes.length; i++) {
      const rec = this.recomendacoes.at(i) as FormGroup;
      const descCtrl = rec.get('descricao');
      const desc = descCtrl?.disabled ? descCtrl?.value : descCtrl?.value;

      if (!desc) {
        this.exibirAviso(`A Recomendação ${i + 1} está vazia`);
        return false;
      }
    }

    return true;
  }

  private verificarPermissoes(): void {
    this.podeEditar =
      !this.modoVisualizacao &&
      (!this.constatacao ||
        this.constatacao.status === 1 ||
        this.constatacao.status === 2);

    const temIdSalvo = !!(this.constatacao && this.constatacao.id);

    const situacaoOk = !!this.form.get('situacaoEncontrada')?.value?.trim();
    const causaOk = !!this.form.get('causa')?.value?.trim();
    const efeitoOk = !!this.form.get('efeito')?.value?.trim();

    const recs = this.recomendacoes;
    const temRecomendacao = recs && recs.length > 0;

    // garante que cada recomendação tem descrição
    let todasRecsOk = true;
    if (temRecomendacao) {
      for (let i = 0; i < recs.length; i++) {
        const desc = recs.at(i).get('descricao')?.value;
        if (!desc || !desc.trim()) {
          todasRecsOk = false;
          break;
        }
      }
    } else {
      todasRecsOk = false;
    }

    this.podeFinalizar =
      this.podeEditar &&
      temIdSalvo &&
      situacaoOk &&
      causaOk &&
      efeitoOk &&
      todasRecsOk;
  }


  private montarDTO(): any {
    const v = this.form.getRawValue();

    return {
      id: v.id,
      situacaoEncontrada: v.situacaoEncontrada,
      causa: v.causa,
      efeito: v.efeito,
      responsavelPreenchimento: this.authService.usuario.id,
      osaExecucaoMatrizConstatacaoId: this.data.matrizId,
      osaExecucaoProgramaTrabalhoQuestaoConstatacaoId: v.osaExecucaoProgramaTrabalhoQuestaoConstatacaoId,
      recomendacoes: (v.recomendacoes || []).map(r => ({
        id: r.id,
        titulo: r.titulo,
        descricao: r.descricao
      }))
    };
  }

  // ==================== MENSAGENS ====================

  private exibirSucesso(mensagem: string): void {
    Swal.fire({
      toast: true,
      position: 'top-end',
      icon: 'success',
      text: mensagem,
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true
    });
  }

  private exibirAviso(mensagem: string): void {
    Swal.fire({
      toast: true,
      position: 'top-end',
      icon: 'warning',
      text: mensagem,
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: true
    });
  }

  private exibirErro(mensagem: string): void {
    Swal.fire({
      toast: true,
      position: 'top-end',
      icon: 'error',
      text: mensagem,
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: true
    });
  }

  public download(arquivo: IOsaExecucaoPapelTrabalhoArquivo) {
    console.log(arquivo);
    this.osaExecucaoPapelTrabalhoService.downloadAnexo(arquivo.arquivoId).then((res) => {
      if (res.sucesso) {
        const link = document.createElement("a");
        link.href = res.dados.toString();0
        link.download = arquivo.nome;
        link.click();
      } else {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          text: res.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    })
  }
  public extrairUrl(texto: string): string {
    if (!texto) return '#';

    // se vier "Link: http://..."
    const t = texto.replace(/^Link:\s*/i, '').trim();
    return t || '#';
  }

  public extrairTextoSemPrefixo(texto: string): string {
    if (!texto) return '';
    return texto
      .replace(/^Arquivo:\s*/i, '')
      .replace(/^Link:\s*/i, '')
      .replace(/^Justificativa:\s*/i, '')
      .trim();
  }
}
